<!-- 网销库存-现货快搜详情页面 -->
<template>
  <div class="business-content-main" style="margin:0 auto;">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div style="max-width: 1000px;margin: 0 auto">
      <div class="detail-top">
        <div class="detail-top-left">
          <div class="image-ctn" v-if="goodsMsg.PictureList && goodsMsg.PictureList[0]">
            <div v-if="goodsMsg.PictureList[coverIndex].IsVideo" class="video-item">
              <video :src="downloadUrl + goodsMsg.PictureList[coverIndex].ImgUrl" controls></video>
            </div>
            <div v-else>
              <img
                style="object-fit:contain;cursor:pointer;"
                :src="downloadUrl + goodsMsg.PictureList[coverIndex].ImgUrl"
                :onerror="defaultImg"
                v-if="goodsMsg.PictureList[0]"
                @click="previewImg($event)"
                title="点击查看大图"
              />
            </div>
          </div>
          <div class="image-ctn" v-else>
            <img :src="noImg" />
          </div>
          <div class="img-main" v-if="goodsMsg.PictureList">
            <div class="go-left" @click="goLeft" v-if="goodsMsg.PictureList.length > 4">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="go-right" @click="goRight" v-if="goodsMsg.PictureList.length > 4">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="toggle-img-ctn" id="toggleImgCtn">
              <div class="image-little-ctn" v-for="(item, index) in goodsMsg.PictureList" :key="index">
                <img
                  @mouseover="toggleCover(index)"
                  v-if="item.IsVideo"
                  src="../../../assets/images/video-icon.png"
                  style="width: 50px;height: 50px"
                />
                <img
                  style="object-fit:contain;"
                  @mouseover="toggleCover(index)"
                  v-else
                  :src="downloadUrl + item.ImgUrl + '?imageView2/2/w/200'"
                  :onerror="defaultImg"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="detail-top-right">
          <div class="goods-name" :title="goodsMsg.GoodsName">{{ goodsMsg.GoodsName }}</div>
          <div class="goods-price">
            <div class="goods-price-item">
              <span class="tb-metatit">价格</span>
              <div class="goods-money">
                <span class="tm-yen">￥</span>
                {{ goodsMsg.SharePrice }}
                <!-- <span class="original-price">{{ goodsMsg.MarketPrice }}</span> -->
              </div>
            </div>
          </div>
          <div class="attributes">
            <span class="attributes-title">库存</span>
            <span>
              {{
              goodsMsg.ShareCount ? goodsMsg.ShareCount : "暂无库存"
              }}
            </span>
          </div>
          <div class="attributes">
            <span class="attributes-title">数量</span>
            <span>
              <el-input-number
                v-model="goodsMsg.buyCount"
                :min="1"
                :max="goodsMsg.ShareCount"
                size="mini"
              ></el-input-number>
            </span>
          </div>
          <div class="goods-msg" style="padding-top: 100px">
            <el-button
              class="buy-btn btn-primary"
              icon="el-icon-shopping-cart-1"
              @click="gotoPay()"
              v-if="permission.buy"
            >{{ permission.buy }}</el-button>
            <el-button icon="el-icon-headset"  type="primary" plain @click="askShareGoods()">联系客服</el-button>
          </div>
        </div>
      </div>
      <div class="goods-dir">
        <div class="dir-tab">
          <div class="tab-item tab-active">商品详情</div>
        </div>
        <div class="goods-introduction">
          <div class="goods-param">
            <div class="title">汽配编码</div>
            <div class="content">{{goodsMsg.APCode}}</div>
            <div class="title">互换码</div>
            <div class="content">{{goodsMsg.GoodsCode}}</div>
          </div>
          <div class="goods-introduction">
            <div class="goods-param">
              <div class="title">适用车型</div>
              <div class="content">{{goodsMsg.AutoSerise}}</div>
              <div class="title">汽配分类</div>
              <div class="content">{{goodsMsg.CateName}}</div>
            </div>
          </div>
          <div class="goods-introduction">
            <div class="goods-param">
              <div class="title">品牌</div>
              <div class="content">{{goodsMsg.Brand}}</div>
              <div class="title">产地</div>
              <div class="content">{{goodsMsg.Origin}}</div>
            </div>
          </div>
          <div class="goods-introduction">
            <div class="goods-param">
              <div class="title">单位</div>
              <div class="content">{{goodsMsg.Unit}}</div>
              <div class="title">材质</div>
              <div class="content">{{goodsMsg.Quality}}</div>
            </div>
          </div>
          <div class="goods-introduction">
            <div class="goods-param">
              <div class="title">配件尺寸</div>
              <div class="content">{{goodsMsg.Size}}</div>
              <div class="title">包装尺寸</div>
              <div class="content">{{goodsMsg.PackageSize}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--查看大图-->
    <bigImage :src="showBigSrc" :show="showBigState" @hide="showBigState = false"></bigImage>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
import bigImage from "@/components/business/service/bigImage.vue";
export default {
  mixins: [mixin],
  name: "",
  components: { bigImage, breadcrumb },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      noImg: this.$util.DEFAULT_IMAGE_square,
      downloadUrl: this.$util.QN_URL_BASE,
      coverIndex: 0,
      userMsg: userMsg,
      goodsId: "",
      goodsMsg: {},
      showBigSrc: "", //显示大图路径
      showBigState: false, // 是否显示大图
      permission: {}
    };
  },
  created() {
    this.goodsId = this.$route.query.id;
    this.permission = this.$util.getPermission("shareInventoryGoodsSearch");
    this.getGoodsDetail();
  },
  methods: {
    goLeft() {
      let ctn = document.getElementById("toggleImgCtn");
      if (ctn.offsetLeft < 0) {
        ctn.style.left = ctn.offsetLeft + 90 + "px";
      }
    },
    goRight() {
      let ctn = document.getElementById("toggleImgCtn");
      if (ctn.offsetWidth + ctn.offsetLeft - 450 >= 0) {
        ctn.style.left = ctn.offsetLeft - 90 + "px";
      }
    },
    previewImg(event) {
      this.showBigSrc = event.target.currentSrc;
      this.showBigState = true;
    },
    // 询问共享网销商品
    askShareGoods() {
      if (this.$store.state.connectState != 2) {
        this.$util.warningMsg("请先连接到客服再进行询问");
        return;
      }
      this.$store.commit("updateAskShareGoods", this.goodsMsg);
      this.$util.successMsg("已向客服发送该商品");
    },
    // 跳转结算页面
    gotoPay() {
      if (this.goodsMsg.buyCount > this.goodsMsg.shareCount) {
        this.$util.warningMsg("商品库存不足");
        return;
      }
      this.$router.push(
        `/shareInventory/siOrderConfirm?goodsId=` +
          this.goodsMsg.GoodsId +
          "&buyQuantity=" +
          this.goodsMsg.buyCount
      );
    },
    toggleCover(index) {
      this.coverIndex = index;
    },
    // 获取商品详情
    getGoodsDetail() {
      let that = this;
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/GetSearchSharedGoods",
          data: {
            goodsId: this.goodsId,
          }
        })
        .then(res => {
          if (res.data) {
            that.goodsMsg = res.data;
            this.$set(that.goodsMsg, "buyCount", 1);
            that.goodsMsg.PictureList.unshift({
              ImgUrl: that.goodsMsg.MainImg,
              IsVideo: false
            });
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
.business-content-main {
  margin: 0 auto;
}
.detail-top {
  display: flex;
  margin-bottom: 30px;
}
.detail-top-left {
  .image-ctn {
    border: 1px solid @border3Color;
    width: 350px;
    height: 350px;
    text-align: center;
    img {
      max-width: 350px;
      max-height: 350px;
    }
  }
  .image-little-ctn {
    width: 80px;
    height: 80px;
    text-align: center;
    margin-right: 18px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.detail-top-left {
  width: 350px;
  min-width: 410px;
  .img-main {
    margin-top: 30px;
    width: 350px;
    height: 80px;
    overflow: hidden;
    position: relative;
    overflow: hidden;
    .go-left {
      cursor: pointer;
      font-size: 26px;
      position: absolute;
      top: 30px;
      left: 0px;
      z-index: 1;
      background: rgba( 255, 255, 255, 0.5);
    }
    .go-right {
      cursor: pointer;
      font-size: 26px;
      position: absolute;
      top: 30px;
      right: 0px;
      z-index: 1;
      background: rgba( 255, 255, 255, 0.5);
    }
  }
  .toggle-img-ctn {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-start;
    .image-ctn {
      cursor: pointer;
      margin-right: 10px;
      max-width: 80px;
      max-height: 80px;
      &:hover {
        border: 3px solid @theme;
      }
    }
  }
}
.detail-top-right {
  flex-grow: 1;
}
.goods-name {
  font-size: 20px;
  font-weight: 700;
}
.goods-money {
  font-size: 28px;
  color: red;
}
.goods-price {
  margin-top: 10px;
  background-color: @border3Color;
  padding: 10px;
  .goods-price-item {
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;
  }
}
.tb-metatit {
  padding-top: 5px;
  color: #999;
  font-size: @font-xs;
  text-align: left;
  float: left;
  width: 75px;
  margin: 0 0 0 8px;
}
.tm-yen {
  color: #ff0036;
  font-size: 18px;
  font-family: Arial;
}
.active {
  border: 1px solid @theme !important;
}
.attributes {
  padding-top: 20px;
}
.attributes-title {
  display: inline-block;
  width: 75px;
  padding-left: 14px;
}
.attributes-item {
  display: inline-block;
  padding: 6px 10px;
  border: 1px solid @font4Color;
  margin-right: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid @theme;
  }
}
.goods-msg {
  display: flex;
  align-items: center;
  height: 39px;
}
.goods-dir {
  width: 100%;
}
.dir-tab {
  background: @border4Color;
  height: 48px;
  line-height: 48px;
  display: flex;
  border-bottom: 1px solid @theme;
  .tab-item {
    cursor: pointer;
    padding: 0 20px;
  }
}
.goods-introduction {
  height: auto;
}
.goods-param {
  display: flex;
  width: 100%;
  height: auto;

  .title {
    background-color: #f2f6fc;
    width: 250px;
    height: 40px;
  }
  .content {
    height: 40px;
  }
  div {
    width: 100%;
    line-height: 40px;
    text-align: center;
    border: 1px solid #dcdfe6;
  }
}
</style>
